/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_EditInputs */

const en_notes_edit = /** @type {(inputs: Notes_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit note`)
};

const pt_br2_notes_edit = /** @type {(inputs: Notes_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar anotação`)
};

/**
* | output |
* | --- |
* | "Edit note" |
*
* @param {Notes_EditInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_edit = /** @type {((inputs?: Notes_EditInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_EditInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_edit(inputs)
	return pt_br2_notes_edit(inputs)
});